import { useSite } from "@/lib/site";
import { Reveal, Kicker } from "./Reveal";

const onMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export const Services = () => {
  const { t } = useSite();
  return (
    <section id="servicios" className="relative py-24 lg:py-36" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-14 grid gap-6 lg:mb-20 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Kicker>{t.services.kicker}</Kicker>
            <h2 className="mt-4 font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-6xl">{t.services.title}</h2>
          </div>
          <p className="text-base text-[var(--muted)] md:text-lg lg:col-span-5">{t.services.sub}</p>
        </Reveal>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {t.services.items.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.id} delay={(i % 3) * 0.08}>
                <article onMouseMove={onMove} className="rb-card group relative h-full overflow-hidden rounded-3xl p-7 hover:-translate-y-0.5 sm:p-8" data-testid={`service-card-${s.id}`}>
                  <div className="spot pointer-events-none absolute inset-0" />
                  <div className="relative flex items-center justify-between">
                    <span className="grid h-12 w-12 place-items-center rounded-2xl border border-[var(--line)] bg-[#8B5CF6]/10 text-[var(--violet-h)] transition-transform duration-500 group-hover:rotate-[-8deg] group-hover:scale-110">
                      <Icon className="h-5 w-5" />
                    </span>
                    <span className="font-mono text-xs text-[var(--faint)]">0{i + 1}</span>
                  </div>
                  <h3 className="relative mt-10 font-display text-2xl font-black tracking-tight">{s.title}</h3>
                  <p className="relative mt-3 text-sm leading-relaxed text-[var(--muted)]">{s.text}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
